import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';
import AvailableFeatureAction from '@app/features/subscription/types/AvailableFeatureAction';
import { PaymentItemType } from '@app/features/subscription/types/PaymentItemType';
import { Subscription } from '@app/store/transport-layer/subscription/subscription';

interface PlanItem {
  type: Extract<PaymentItemType, 'PLAN'>;
  planId: string;
}

interface AvailableFeatureItem {
  action: AvailableFeatureAction;
  quantity: number;
  type: Extract<PaymentItemType, 'AVAILABLE_FEATURE'>;
}

type PaymentItem = AvailableFeatureItem | PlanItem;

interface ChangeSubscriptionPlanParam {
  items: PaymentItem[];
}

export type ChangeSubscriptionPlanResponse = Subscription;

/**
 * 정기결제 변경
 */
export function changeSubscriptionPlan(workspaceId: string, data: ChangeSubscriptionPlanParam) {
  return requestApi<ChangeSubscriptionPlanResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription/plan`),
    method: 'PUT',
    credentials: true,
    data,
  }).then((response) => response.data);
}
